import styled from 'styled-components';
import { StyledBadge } from '../../Badge/style';

export const Overlay = styled.div`
  position: absolute;
  height: inherit;
  width: inherit;
  background: linear-gradient(
    0deg,
    #050505 -13.37%,
    rgba(255, 255, 255, 0) 104.73%
  );
  border-radius: 4px 4px 0 0;
`;

export const Label = styled.div`
  position: relative;
  width: fit-content;
  min-width: 96px;
  max-width: 160px;
  padding: 0 10px;
  height: auto;
  border-radius: 8px;
  font-weight: bold;
  text-align: center;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textPrimary};
  text-transform: uppercase;
  z-index: 1;
  font-style: normal;
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
  z-index: 2;

  &.small-cover {
    width: 112px;
  }
`;

export const Mandatory = styled.div`
  background-color: ${(props) => props.theme.colors.mandatory};
  color: ${(props) => props.theme.colors.white};
  position: relative;
  bottom: 6px;
  left: 0;
  width: fit-content;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  padding-left: 40px;
  padding-right: 12px;
  border-radius: 9px;
  z-index: 1;

  &.small-cover {
    width: 112px;
    padding: 10px 0 0;
    text-align: center;
    border-radius: 0px 0px 9px 9px;
  }
`;

export const Bookmark = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  position: absolute;
  right: 16px;
  top: 12px;
  z-index: 2;
  cursor: pointer;
  padding: 8px;
  border-radius: 100%;
  display: flex;

  & svg {
    stroke: ${(props) => props.theme.colors.title};
  }
`;

export const Icon = styled.span`
  font-size: ${({ size }) => (size ? `${size}px` : '16px')};
  color: ${(props) => props.theme.colors.white};
  margin-right: 5px;
`;

export const CardDetails = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  position: absolute;
  bottom: 8px;
  left: 8px;
  width: calc(100% - 16px);
  gap: 16px;

  > div:first-child {
    width: fit-content;
  }

  &.small-cover {
    flex-wrap: wrap;

    .last {
      margin-left: 0;
    }
  }
`;

export const Detail = styled.div`
  display: flex;
  align-items: center;

  &.last {
    margin-left: auto;
    border: 1px solid ${(props) => props.theme.colors.white};
    border-radius: 9px;
    padding: 0 12px;
    color: ${(props) => props.theme.colors.white};
  }

  & svg {
    fill: ${(props) => props.theme.colors.transparent};
    stroke: ${(props) => props.theme.colors.white};
    margin-left: 5px;
  }
`;

export const Line = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const Expired = styled.div`
  color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  position: absolute;
  top: 80px;
  left: 50%;
  padding: 8px;
  border-radius: 8px;
  transform: translate(-50%, 0) rotate(-15deg);
  z-index: 0;
  background-color: ${(props) => props.theme.colors.expired};

  .h2-5 {
    text-transform: uppercase;
    font-size: 24px !important;
  }
`;

export const BadgeWrapepr = styled.div`
  position: absolute;
  top: 12px;
  left: 16px;
  display: flex;
  gap: 8px;

  > ${StyledBadge} {
    height: fit-content;
  }
`;
